<template>
  <div class="new_box">
    <div class="banner">
      <!-- <img src="../assets/news首页.png" alt=""> -->
        <h1>新闻</h1>
        <div class="inner_btn">
            <button @click="goToContact(2)" class="inner-le">生态合作</button>
            <button @click="goToContact(3)" class="inner-ri">联系我们</button>
         </div>
    </div>
  </div>
  <div class="new-main">
    <div class="left">
      <div class="item" v-for="item in newsALL" :key="item.id">
        <div class="item1">
          <img :src="item.thumbnail" alt="">
        </div>
        <div class="item3">
          <h2>{{ splitDate(item.newsTime).month+'-'+splitDate(item.newsTime).day }}</h2>
          <h5>{{splitDate(item.newsTime).year}}</h5>
        </div>
        <div class="item2" @click="goto_detailnew(item.id)">
          <h4 class="item2title">{{ item.name }}</h4>
          <p class="item2text">{{ item.description }}</p>
        </div>
      </div>
    </div>
    <!-- <div class="right">
      <div class="box">
        <div class="box-main">
          <h3>热门文章</h3>
          <ul v-for="item in 5" :key="item">
            <li @click="goto_itemnews" style="cursor: pointer;">item:{{ item }}</li>
          </ul>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script setup name="NewsMess">
import { onMounted ,ref} from 'vue';
import { useRouter } from 'vue-router';
import { getNewsList } from '@/api/news'
const router = useRouter();
const newsALL=ref([])
onMounted(() => {
  window.scrollTo(0, 0);
  solutionrender()
})
const emit = defineEmits(['scroll-to-contact'])
function goToContact(type) {
  emit('scroll-to-contact', type)
}
async function solutionrender() {
  const params = {
    appId: window.location.pathname.startsWith('/en') ? 2 : 1,
    objectType: 'new',
    current: 1,
    size: 100
  }
  const new_res = await getNewsList(params)
  const records = (new_res.data || []).slice()
  records.sort((a, b) => (b.top || 0) - (a.top || 0))
  newsALL.value = records
}
function goto_detailnew(id){
  router.push(`/newsdetail?id=${id}`)
}
function splitDate(dateStr) {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    return null;
  }
  return {
    year: date.getFullYear(),
    month: String(date.getMonth() + 1).padStart(2, '0'),
    day: String(date.getDate()).padStart(2, '0')
  };
}
</script>

<style scoped>
.new_box{
  width: 100%;
}
.banner{
  overflow: hidden;
  width: 100%;
  height: 11em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color:white;
  background-color: #ddd;
  margin-bottom: 4em;
  background-image: url('https://official-web-static.womucloud.com/bigBanner/pc/news.jpg');
  background-size: cover;
  background-position: center;
  text-align: center;
  background-repeat: no-repeat;
}

.inner_btn{
  font-size: 1em;
}
.inner-le,.inner-ri{
  width: 10em;
  height: 3em;
  border-radius: 1.5em;
  font-size: 1em;
  border:transparent;
  cursor: pointer;
  margin: 0.5em auto;
}
.inner-le{
  background-color: orange;
  color: white;
  margin-right: 1em;
}
.inner-ri{
  background-color: skyblue;
  color: white;
}
.banner h1{
  width: 65%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin: 0 auto;
  color: white;
}
.item2title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 控制显示的行数 */
  overflow: hidden;
  text-overflow: ellipsis;
}
.new-main{
  display: flex;
  width: 60%;
  margin: 2em auto;
  margin-bottom: 0;
}
.left{
  width: 100%;
  height: 100%;
  border-top:1px dashed #ddd;
  /* background-color: #999797; */
}
.right{
  width: 30%;
  height: 100%;
  /* background-color: #535252; */
}
.item{
  display: flex;
  overflow: hidden;
  justify-content: space-between;
  width: 100%;
  height: 12em;
  margin: 2em auto;
  padding: 0 0 2em 0;
  border-bottom:1px dashed #ddd;
}
.item .item1{
  width: 26%;
  height: 100%;
  background-color: #ddd;
}
.item1 img{
  width: 100%;
  height: 100%;
}
.item .item3{
  width: 8%;
  margin-top: 1em;
}
.item .item3 h2{
  font-weight: 400;
}
.item .item3 h5{
  font-weight: 400;
}
.item .item2{
  width: 60%;
  height: 100%;
  background-color:#fff;;
}
.item .item2 h4{
  cursor: pointer;
  margin-top: 1em;
  margin-bottom: 1em;
  font-size: 1.2em;
  font-weight: 400;
}
.item .item2 h4:hover{
  color: #FF6B02;
}
.item .item2 p{
  width: 90%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 控制显示的行数 */
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.8em;
  margin-bottom: 2em;
  font-size: 1em;
}
.box{
  width: 90%;
  border:1px solid #ddd;
  margin: 2em auto;
  border-radius: 5px;
  box-shadow: 0px 0px 6px 1px #ddd;
}
.box-main{
  width: 90%;
  height: 100%;
  margin: 0 auto;
}
.box-main h3{
  height: 60px; 
  line-height: 60px;
  border-bottom: 1px solid #ddd;
}
.box-main ul{
  width: 100%;
  height: 100%;
}
.box-main ul li{
  list-style: none;
  margin-top: 1.5em;
}
.box-main ul:last-child{
  margin-bottom: 3em;
}
.el-card{
  width: 80%;
  height: 50%;
  margin: 0 auto;
}
@media (max-width: 1024px)  {
  .banner{
    height: 11em;
    background-image: url('https://official-web-static.womucloud.com/bigBanner/m/news.jpg');
    margin-bottom: 1em;
    text-align: center;
    gap: 0.8em;
  }
  .banner h1{
    font-size: 1.2em;
  }
  .inner-le,.inner-ri{
    font-size: 0.8em;
    height: 2.5em;
  }
.new-main{
  display: flex;
  width: 90%;
  margin: 2em auto;
}
.item{
  height: 8em;
  margin: 1em auto;
  padding: 1em;
}
.item .item1{
  width: 29%;
  height: 100%;
  background-color: #ddd;
}
.item .item3{
  width: 12%;
}
.item .item3 h5{
  font-size: 0.5em;
}
.item .item2{
  width: 50%;
}
.item .item2 h4{
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  font-size: 0.5em;
}
.item .item2 p{
  width: 90%;
  margin-bottom: 2em;
  font-size: 0.5em;
}
}
</style>